__webpack_require__.p = "https://assets.simple.life/static/cloudflare/releases/v0.475.0/";